import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  ListItemButton,
  ListItem,
  ListItemText,
  TextField,
  ListItemSecondaryAction,
  Button,
  Paper,
  Stack,
} from '@mui/material';
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';

const useStyles = () => ({
  root: {
    cursor: 'text',
    width: '100%',
  },
});

/**
 * MuiListItemButton element to add a new template:
 *
 * @param {Object} props - Object. Component's props object.
 * @param {Boolean} props.open - Boolean. Flag indicating if the scope group's accordion is open.
 * @param {Function} props.handleAddNew - Callback. Creates and adds a new element  with the provided name.
 *
 * @returns {React.JSX.Element}
 */

const NewElementBtn = function NewElementBtn({
  handleAddNew = () => {},
  open = false,
  paper = false,
  text = '',
  withSubject = false,
}) {
  const intl = useIntl();
  const classes = useStyles();

  const [inEdit, setInEdit] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const [subjectValue, setSubjectValue] = useState('');

  useEffect(() => {
    if (inEdit) setInEdit(false);
  }, [open]);

  const toggleInEdit = () => {
    setInEdit(!inEdit && open);
  };

  const handleChangeInputValue = (event) => {
    setInputValue(event.target.value);
  };

  return !inEdit ? (
    <ListItemButton
      id="add-template-listItemBtn"
      onClick={toggleInEdit}
      sx={classes.root}
      component={paper ? Paper : null}
    >
      <ListItemText primary={text} />
    </ListItemButton>
  ) : (
    <ListItem sx={classes.root} component={paper ? Paper : null}>
      <Stack spacing={1} sx={{ pr: '72px', width: '100%' }}>
        <TextField
          autoFocus
          size="small"
          label={withSubject ? intl.messages.NAME : undefined}
          value={inputValue}
          onChange={handleChangeInputValue}
        />
        {withSubject && (
          <TextField
            id="new-template-subject-txtfield"
            size="small"
            label={intl.messages.SUBJECT}
            value={subjectValue}
            onChange={(event) => setSubjectValue(event.target.value)}
            slotProps={{ htmlInput: { maxLength: 64 } }}
          />
        )}
      </Stack>
      <ListItemSecondaryAction>
        <Button
          variant="outlined"
          onClick={() => {
            toggleInEdit();
            if (inputValue) {
              handleAddNew(inputValue, subjectValue);
              setInputValue('');
              setSubjectValue('');
            }
          }}
        >
          <DoneRoundedIcon />
        </Button>
      </ListItemSecondaryAction>
    </ListItem>
  );
};

NewElementBtn.propTypes = {
  handleAddNew: PropTypes.func,
  open: PropTypes.bool,
  paper: PropTypes.bool,
  text: PropTypes.string,
};
export default NewElementBtn;
